import {styles} from '../styles';

export function Title(props) {
    const {className, title} = props;

    return <div class={className ? `${className} ${styles.classes.title}` : styles.classes.title}>{title}</div>;
}
